import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sauceToken: null,
  selectedEvent: null,
  selectedOrderId: null,
  selectedTicketId: null, // changes
  selectedEventDetails:null,
  tokenDetail:null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    removeData:(state,action)=>{
      state.tokenDetail=null;
      state.sauceToken=null;
      state.selectedEvent=null;
      state.selectedOrderId=null;
      state.selectedTicketId=null;
      state.selectedEventDetails=null;
    },
    setTokenDetails:(state,action)=>{
      state.tokenDetail=action?.payload;
    },
    setSauceToken: (state, action) => {
      state.sauceToken = action.payload;
    },
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
    setSelectedEventDetails:(state,action)=>{
      state.selectedEventDetails=action.payload;
    },
    setSelectedOrderId: (state, action) => {
      state.selectedOrderId = action.payload;
    },
    setSelectedTicketId: (state, action) => {
      state.selectedTicketId = action.payload;
    },
  },
});

export const { setSauceToken,removeData, setSelectedEvent,setSelectedEventDetails, setSelectedOrderId, setSelectedTicketId ,setTokenDetails} =
  userSlice.actions;

export const getTicketSauceToken = (state) => state.user.sauceToken;
export const getSelectedEvent = (state) => state.user.selectedEvent;
export const getSelectedEventDetails = (state) => state.user.selectedEventDetails;
export const getSelectedOrderId = (state) => state.user.selectedOrderId;
export const getSelectedTicketId = (state) => state.user.selectedTicketId;
export const getSelectedTokenDetails = (state) => state.user.tokenDetail;
export default userSlice.reducer;
